import url from "/vercel/path0/src/assets/icons/BannerGradient.svg?url";
export default url;
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBannerGradient = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 789,
	height: 164,
	viewBox: "0 0 789 164",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M550.222 119.681C406.54 141.593 365.066 197.619 329.488 212.651C329.242 212.755 329.012 212.879 328.79 213.029L225.828 282.505C222.437 284.793 224.26 290.093 228.341 289.812L871.936 245.376C873.907 245.24 875.483 243.686 875.647 241.718L900.201 -52.6034C900.443 -55.5054 897.595 -57.7016 894.813 -56.841C865.684 -47.8307 836.251 -47.2568 766.341 27.0795C734.173 61.2837 745.935 89.8328 550.222 119.681Z",
			fill: "#59CEFA",
			fillOpacity: .21
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M330.523 106.571C189.516 128.348 148.806 184.025 113.889 198.971C113.642 199.077 113.411 199.203 113.189 199.354L10.7095 269.382C7.46135 271.601 9.03215 276.684 12.9662 276.684H728.586C730.082 276.684 731.454 275.849 732.14 274.519L884.509 -20.7564C885.718 -23.0994 884.37 -25.9508 881.791 -26.5022L675.647 -70.5867C674.912 -70.7438 674.144 -70.6877 673.436 -70.4376C643.188 -59.7611 615.014 -63.4021 542.636 14.5344C511.065 48.5299 522.608 76.905 330.523 106.571Z",
			fill: "#91E1FF",
			fillOpacity: .29
		})
	]
});
const ForwardRef = forwardRef(SvgBannerGradient);
export { ForwardRef as ReactComponent };
